import { IRehabBooking, IRehabBookingInput } from "../../types/api";

export const getRehabSlotsByAdminQueryFn = (date: string) => {
  const dateString = date.slice(0, 10);
  const query = `
        getRehabSlotsAdmin(date: $date) {
            ... on RehabSummary {
                __typename
                slots {
                    booking {
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                    }
                    updated_at
                    start_time
                    end_time
                    created_at
                    available_for_member_type
                    bookable
                    comment
                }
                rehab_id
                date
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$date: String!`;
  const variables = { date: dateString };
  return {
    query,
    inputs,
    variables,
  };
};

export const getRehabSlotsQueryFn = (date: string, member_id: string) => {
  const dateString = date.slice(0, 10);
  const query = `
        getRehabSlots(date: $date, member_id: $member_id) {
            ... on RehabSummary {
                __typename
                slots {
                    booking {
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                    }
                    updated_at
                    start_time
                    end_time
                    created_at
                    available_for_member_type
                    bookable
                    comment
                }
                rehab_id
                date
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$date: String!, $member_id: String!`;
  const variables = { date: dateString, member_id: member_id };
  return {
    query,
    inputs,
    variables,
  };
};

export const createRehabBookingQueryFn = (
  bookingToCreate: IRehabBookingInput,
  sendEmail: boolean,
  isAdmin: boolean
) => {
  const query = `
        createRehabBooking(input: $input, send_email: $send_email, admin: $admin) {
            ... on RehabBooking {
                __typename
                datetime_end
                datetime_start
                flag
                member_id
                integration_id
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$input: RehabBookingInput! $send_email: Boolean! $admin: Boolean!`;
  const variables = {
    input: bookingToCreate,
    send_email: sendEmail,
    admin: isAdmin,
  };
  return {
    query,
    inputs,
    variables,
  };
};

export const cancelRehabBookingQueryFn = (
  input: IRehabBooking,
  sendEmail: boolean,
  isAdmin: boolean
) => {
  const datetime_start = input.datetime_start;
  const datetime_end = input.datetime_end;
  const member_id = input.member_id;
  const flag = input.flag;

  const query = `
        cancelRehabBooking(input: $input, send_email: $send_email, admin: $admin) {
            ... on RehabBooking {
                __typename
                datetime_end
                datetime_start
                flag
                member_id
                integration_id
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$input: RehabBookingInput, $send_email: Boolean!, $admin: Boolean!`;
  const variables = {
    input: { datetime_start, datetime_end, member_id, flag },
    send_email: sendEmail,
    admin: isAdmin,
  };
  return {
    query,
    inputs,
    variables,
  };
};

export const getActiveRehabBookingsByMemberQueryFn = (
  member_id: string,
  active: boolean
) => {
  const query = `
            getActiveRehabBookingsByMember(member_id: $member_id, active: $active) {
                ... on RehabBooking {
                    __typename
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                }
                ... on Error {
                    code
                    message
                }
            }
        `;
  const inputs = `$member_id: String!, $active: Boolean!`;
  const variables = { member_id: member_id, active: active };
  return {
    query,
    inputs,
    variables,
  };
};

export const getRehabSlotsWeeklyQueryFn = (date: string) => {
  const dateString = date.slice(0, 10);
  const query = `
        getRehabSlotsWeekly(date: $date) {
            ... on RehabSummary {
                __typename
                date
                slots {
                    booking {
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                    }
                    updated_at
                    start_time
                    end_time
                    created_at
                    available_for_member_type
                    bookable
                    comment
                }
                rehab_id
                date
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$date: String!`;
  const variables = { date: dateString };
  return {
    query,
    inputs,
    variables,
  };
};

export const changeRehabSlotBookabilityQueryFn = (
  datetime: string,
  bookable: boolean
) => {
  const query = `
        changeRehabSlotBookability(datetime: $datetime, bookable: $bookable) {
            ... on RehabSummaryItem {
                __typename
                	start_time
                end_time
                booking {
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                }
                updated_at
                created_at
                available_for_member_type
                bookable
                comment
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$datetime: String! $bookable: Boolean!`;
  const variables = { datetime: datetime, bookable: bookable };
  return {
    query,
    inputs,
    variables,
  };
};

export const createRehabSlotCommentQueryFn = (
  datetime: string,
  comment: string
) => {
  const query = `
        createRehabSlotComment(datetime: $datetime, comment: $comment) {
            ... on RehabSummaryItem {
                __typename
                	start_time
                end_time
                booking {
                    datetime_end
                    datetime_start
                    flag
                    member_id
                    integration_id
                }
                updated_at
                created_at
                available_for_member_type
                bookable
                comment
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$datetime: String!, $comment: String!`;
  const variables = { datetime: datetime, comment: comment };
  return {
    query,
    inputs,
    variables,
  };
};
